export const isMobile = () =>  window.innerWidth < 1056;
